import React, { useState } from 'react';
import { SearchIcon, BellIcon, SettingsIcon, SunIcon } from 'lucide-react';
import type { Section } from '../../App';
const sectionTitles: Record<Section, string> = {
  dashboard: 'Dashboard',
  halloffame: 'Hall of Fame',
  videos: 'Video Library',
  directory: 'Company Directory',
  launchpad: 'Launchpad',
  learning: 'Learning Center',
  meetingroom: 'Meeting Rooms'
};
const tickerItems = [{
  text: '⚠️ URGENT: New TRID Disclosure Requirements effective March 15 — complete training by March 10',
  urgent: true
}, {
  text: '🎉 Swift Home Loans hits $1 BILLION in annual volume — company record!',
  urgent: false
}, {
  text: '📊 Updated Rate Sheets now live in Launchpad — discard sheets prior to March 1',
  urgent: false
}, {
  text: '🛠️ Encompass maintenance Saturday 2–4 AM PST — plan accordingly',
  urgent: false
}, {
  text: '👋 Welcome 5 new team members: Alex Chen, Maria Santos, James Park, Tanya Williams & David Kim!',
  urgent: false
}, {
  text: '📅 Q1 All-Hands Meeting — March 5 at 10 AM · Zoom or HQ Conference Room A · Attendance mandatory',
  urgent: true
}, {
  text: '🏆 Sarah Kim closes 100th loan — a Swift milestone! Congratulations!',
  urgent: false
}, {
  text: '📘 NMLS Annual Renewal due April 30 — start your CE hours in the Learning Center now',
  urgent: false
}];
interface TopBarProps {
  activeSection: Section;
  setActiveSection: (s: Section) => void;
  sidebarCollapsed: boolean;
}
export function TopBar({
  activeSection
}: TopBarProps) {
  const [searchValue, setSearchValue] = useState('');
  const hour = new Date().getHours();
  const greeting = hour < 12 ? 'Good morning' : hour < 17 ? 'Good afternoon' : 'Good evening';
  return <div style={{
    flexShrink: 0
  }} data-id="element-39">
      {/* Main TopBar */}
      <header style={{
      display: 'flex',
      alignItems: 'center',
      gap: 16,
      padding: '0 24px',
      background: '#FFFFFF',
      borderBottom: '1px solid #E4EAF6',
      minHeight: 60,
      boxShadow: '0 1px 4px rgba(13,27,42,0.06)',
      position: 'relative'
    }} data-id="element-40">
        {/* Bottom accent line */}
        <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: 2,
        background: 'linear-gradient(90deg, #2B8DC4 0%, #3FA8E0 40%, transparent 100%)'
      }} data-id="element-41" />

        <div style={{
        flex: 1,
        minWidth: 0
      }} data-id="element-42">
          <div style={{
          fontSize: 11,
          fontWeight: 600,
          color: '#A0AECB',
          letterSpacing: '0.04em'
        }} data-id="element-43">
            {greeting}, Jamie 👋
          </div>
          <h1 style={{
          fontSize: 16,
          fontWeight: 900,
          color: '#1A2B3C',
          margin: 0,
          fontStyle: 'italic',
          letterSpacing: '-0.02em',
          lineHeight: 1.2
        }} data-id="element-44">
            {sectionTitles[activeSection]}
          </h1>
        </div>

        {/* Search */}
        <div style={{
        position: 'relative'
      }} data-id="element-45">
          <SearchIcon size={15} style={{
          position: 'absolute',
          left: 10,
          top: '50%',
          transform: 'translateY(-50%)',
          color: '#A0AECB'
        }} data-id="element-46" />
          <input type="text" placeholder="Search people, posts, tools..." value={searchValue} onChange={e => setSearchValue(e.target.value)} style={{
          paddingLeft: 32,
          paddingRight: 16,
          paddingTop: 8,
          paddingBottom: 8,
          fontSize: 13,
          borderRadius: 8,
          border: '1.5px solid #E4EAF6',
          background: '#F4F8FC',
          color: '#1A2B3C',
          outline: 'none',
          width: 260
        }} onFocus={e => {
          e.target.style.borderColor = '#2B8DC4';
          e.target.style.boxShadow = '0 0 0 3px rgba(43,141,196,0.12)';
        }} onBlur={e => {
          e.target.style.borderColor = '#E4EAF6';
          e.target.style.boxShadow = 'none';
        }} data-id="element-47" />
        </div>

        {/* Actions */}
        <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 4
      }} data-id="element-48">
          <button style={{
          position: 'relative',
          padding: 8,
          borderRadius: 8,
          background: 'none',
          border: 'none',
          cursor: 'pointer'
        }} data-id="element-49">
            <BellIcon size={19} color="#5A6A8A" data-id="element-50" />
            <span style={{
            position: 'absolute',
            top: 6,
            right: 6,
            width: 8,
            height: 8,
            background: '#2B8DC4',
            borderRadius: '50%',
            border: '2px solid white'
          }} data-id="element-51" />
          </button>
          <button style={{
          padding: 8,
          borderRadius: 8,
          background: 'none',
          border: 'none',
          cursor: 'pointer'
        }} data-id="element-52">
            <SettingsIcon size={19} color="#5A6A8A" data-id="element-53" />
          </button>
          <div style={{
          width: 34,
          height: 34,
          borderRadius: 9,
          background: 'linear-gradient(135deg, #2B8DC4, #1E6FA0)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 12,
          fontWeight: 800,
          color: 'white',
          cursor: 'pointer',
          transform: 'skewX(-4deg)',
          marginLeft: 4
        }} data-id="element-54">
            JD
          </div>
        </div>
      </header>

      {/* ESPN-Style News Ticker */}
      <div style={{
      background: '#1A2B3C',
      borderBottom: '2px solid #2B8DC4',
      display: 'flex',
      alignItems: 'center',
      height: 34,
      overflow: 'hidden',
      position: 'relative'
    }} data-id="element-55">
        {/* Label */}
        <div style={{
        flexShrink: 0,
        background: '#2B8DC4',
        color: 'white',
        fontWeight: 900,
        fontSize: 11,
        letterSpacing: '0.08em',
        padding: '0 14px',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        fontStyle: 'italic',
        zIndex: 2,
        whiteSpace: 'nowrap',
        clipPath: 'polygon(0 0, calc(100% - 8px) 0, 100% 50%, calc(100% - 8px) 100%, 0 100%)',
        paddingRight: 22
      }} data-id="element-56">
          ⚡ SWIFT NEWS
        </div>
        <div style={{
        width: 2,
        height: '100%',
        background: '#1E6FA0',
        flexShrink: 0
      }} data-id="element-57" />

        {/* Scrolling ticker */}
        <div style={{
        flex: 1,
        overflow: 'hidden',
        position: 'relative',
        height: '100%',
        display: 'flex',
        alignItems: 'center'
      }} data-id="element-58">
          <div className="ticker-scroll" style={{
          display: 'flex',
          alignItems: 'center',
          whiteSpace: 'nowrap'
        }} data-id="element-59">
            {[0, 1].map(copy => <span key={copy} style={{
            display: 'inline-flex',
            alignItems: 'center'
          }} data-id="element-60">
                {tickerItems.map((item, i) => <span key={i} style={{
              display: 'inline-flex',
              alignItems: 'center'
            }} data-id="element-61">
                    <span style={{
                fontSize: 12,
                fontWeight: item.urgent ? 700 : 500,
                color: item.urgent ? '#E8A020' : 'rgba(255,255,255,0.85)',
                padding: '0 4px'
              }} data-id="element-62">
                      {item.text}
                    </span>
                    <span style={{
                color: '#2B8DC4',
                fontWeight: 900,
                fontSize: 14,
                padding: '0 16px',
                opacity: 0.8
              }} data-id="element-63">
                      ◆
                    </span>
                  </span>)}
              </span>)}
          </div>
        </div>

        {/* Right fade */}
        <div style={{
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        width: 60,
        background: 'linear-gradient(to left, #1A2B3C, transparent)',
        pointerEvents: 'none',
        zIndex: 2
      }} data-id="element-64" />
      </div>
    </div>;
}